import React, { createContext, useContext } from "react";

interface CMSConfig {
  lineLiffId?: string;
  officialAccountId?: number;
  apiToken?: string;
  apiBaseUrl?: string;
  divisionId?: number;
}

const CMSConfigContext = createContext<CMSConfig>({});

export const CMSConfigProvider: React.FC<{ config: CMSConfig; children: React.ReactNode }> = ({
  config,
  children,
}) => <CMSConfigContext.Provider value={config}>{children}</CMSConfigContext.Provider>;

export const useCMSConfig = () => useContext(CMSConfigContext);

export const useLiffUrl = () => {
  const { lineLiffId, officialAccountId } = useContext(CMSConfigContext);
  return lineLiffId
    ? `https://liff.line.me/${lineLiffId}${officialAccountId ? `?oa=${officialAccountId}` : ""}`
    : null;
};
